import bella_plus from './albums/bella_plus.jpeg';
import bella from './albums/bella.jpeg';
import camel from './albums/camel.jpeg'
import elegance from './albums/elegance.jpeg';
import elizabeth from './albums/elizabeth.jpeg';
import emily from './albums/emily.jpeg';
import even from './albums/even.jpeg';
import flora from './albums/flora.jpeg';
import fotokapak from './albums/fotokapak.jpeg';
import leinen from './albums/leinen.jpeg';
import lima from './albums/lima.jpeg';
import liva from './albums/liva.jpeg';
import lowra from './albums/lowra.jpeg';
import luna_plus from './albums/luna_plus.jpeg';
import luna from './albums/luna.jpeg';
import magneto from './albums/magneto.jpeg';
import marvel from './albums/marvel.jpeg';
import medusa from './albums/medusa.jpeg';
import montana from './albums/montana.jpeg';
import nubuk from './albums/nubuk.jpeg';
import rachel from './albums/rachel.jpeg';
import reina from './albums/reina.jpeg';
import ruby from './albums/ruby.jpeg';
import saha from './albums/saha.jpeg';
import september from './albums/september.jpeg';
import sieana from './albums/sieana.jpeg';
import square from './albums/square.jpeg';
import straw from './albums/straw.jpeg';
import tokyo from './albums/tokyo.jpeg';
import velvet from './albums/velvet.jpeg';
import window_plus from './albums/window_plus.jpeg';
import window from './albums/window.jpeg';
import wood_plus from './albums/wood_plus.jpeg';
import wood from './albums/wood.jpeg';
import root from './albums/root.jpeg';
import simple from './albums/simple.jpeg';
import sandik_1 from './albums/sandik_1.jpeg';
import sandik_2 from './albums/sandik_2.jpeg';

export {
    bella_plus,
    bella,
    camel,
    elegance,
    elizabeth,
    emily,
    even,
    flora,
    fotokapak,
    leinen,
    lima,
    liva,
    lowra,
    luna_plus,
    luna,
    magneto,
    marvel,
    medusa,
    montana,
    nubuk,
    rachel,
    reina,
    ruby,
    saha,
    september,
    sieana,
    square,
    straw,
    tokyo,
    velvet,
    window_plus,
    window,
    wood_plus,
    wood,
    root,
    simple,
    sandik_1,
    sandik_2
};


// WEBPACK FOOTER //
// ./src/assets/img/index.js